export default __webpack_public_path__ + "media/color/xrp-d8e11d09.svg";